const block_icon     = {
    counter_icon:<svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-icon"
    style={{ width: "1em", height: "1em", verticalAlign: "middle" }}
    fill="currentColor"
    overflow="hidden"
    viewBox="0 0 1024 1024"
    >
    <g xmlns="http://www.w3.org/2000/svg" fill="red">
    <path d="M170.667 170.667h682.666A85.333 85.333 0 01938.667 256v512a85.333 85.333 0 01-85.334 85.333H170.667A85.333 85.333 0 0185.333 768V256a85.333 85.333 0 0185.334-85.333m0 85.333v512h298.666V256H170.667m682.666 512V256h-52.906c10.24 23.04 8.106 45.653 8.106 48.213-2.986 28.587-23.04 58.454-30.293 69.12l-99.413 108.8 141.653-.853.427 52.053-221.867-1.28-1.707-42.666S727.467 351.573 733.867 339.2C739.84 327.253 764.16 256 704 256c-52.48 2.133-46.507 55.467-46.507 55.467l-65.706.426S592.213 283.733 608 256h-53.333v512h110.08l-.427-36.693 41.387-.427s38.826-6.827 39.253-44.8c1.707-42.667-34.56-42.667-40.96-42.667-5.547 0-45.653 2.134-45.653 37.12h-64.854S595.2 592.64 704 592.64c110.933 0 104.96 86.187 104.96 86.187s1.707 53.333-47.36 73.386L783.787 768h69.546m-472.746-85.333h-64V435.2l-76.8 23.893v-52.48l133.973-47.786h6.827v323.84z"></path>
   </g>
    </svg>
}
export default block_icon;